import { first, size } from 'lodash-es'
import { getStoredBusinessId, setStoredBusinessId } from 'lib/helpers/businessIdStorage/businessIdStorage'
import type { ResolveLocalStorageBusinessId_ProfileFragment } from './resolveLocalStorageBusinessId.graphql'

/** Writes the resolved id back to storage, so later calls return that first pick rather than redoing it. */
export const resolveLocalStorageBusinessId = (
  profile: Maybe<ResolveLocalStorageBusinessId_ProfileFragment>,
): string | null => {
  const { actions, memberships, accountingFirms } = profile ?? {}

  let businessId: string | null = getStoredBusinessId()

  if (businessId) {
    return businessId
  }

  const viewAccountantDashboardAllowed = Boolean(actions?.viewAccountantDashboard?.allowed)

  if (viewAccountantDashboardAllowed && size(accountingFirms) > 0) {
    businessId = first(accountingFirms)?.id ?? null
  } else {
    businessId = first(memberships?.filter(({ business }) => business))?.business?.id ?? null
  }

  if (businessId) {
    setStoredBusinessId(businessId)
  }

  return businessId
}
